import React from 'react'

function Banner() {
  return (
    <div className='banner blogBanner'>
         <div>
            <h1 className='text-center'>Recent <span style={{color: '#569A44'}}>News</span> Articles</h1>
            <p className='text-center'>Stay updated with the latest news and articles from the world of biology and healthcare.</p>
        </div>
    </div>
  )
}

export default Banner